import FormValidations from "./FormValidations";
import {ErrorVisibilityManager} from "./ErrorVisibilityManager";
import {InputErrorManager, InputValidationHandler, InputValidator} from "./InputValidationHandler";

export class NameValidationHandler implements InputValidator, InputErrorManager{
    private constructor() {
    }

    static create(element: HTMLInputElement) {
        const nameValidationHandler = new NameValidationHandler()
        return new InputValidationHandler(
            element,
            nameValidationHandler,
            nameValidationHandler
        );
    }

    isValid(element: HTMLInputElement): boolean {
        return FormValidations.isNotEmpty(element.value)
    }

    manageError(element: HTMLInputElement, isValid: boolean): void {
        ErrorVisibilityManager.manageErrorVisibility(element, isValid);
    }
}
